<template>
    <div class="safe-payments">
        <img :src="require(`../../assets/images/${systemConst.SYSTEM_SAFE_PAYMENT_ICON}`)" :alt="systemConst.SYSTEM_PAYMENT_METHOD" :title="systemConst.SYSTEM_PAYMENT_METHOD">
        <span>Bezpieczna płatność obsługiwana przez </span>
        <img v-if="isCardSubscription" :src="require(`../../assets/images/${systemConst.SYSTEM_PAYMENT_LOGO_STRIPE}`)" :alt="systemConst.SYSTEM_PAYMENT_METHOD_STRIPE" :title="systemConst.SYSTEM_PAYMENT_METHOD_STRIPE">
        <img v-else :src="require(`../../assets/images/${systemConst.SYSTEM_PAYMENT_LOGO}`)" :alt="systemConst.SYSTEM_PAYMENT_METHOD" :title="systemConst.SYSTEM_PAYMENT_METHOD">
    </div>
</template>

<script>
import systemConst from '@SYSTEM_CONSTANTS'
import {mapGetters} from "vuex";
import paymentMethods from "@/constants/paymentMethods";

export default {
    name: 'SafePayment',
    data () {
        return {
            systemConst
        }
    },
    computed: {
      ...mapGetters([
        'currentMethod',
      ]),
      isCardSubscription() {
        return paymentMethods.CARD === this.currentMethod;
      },
    },
}
</script>
